import { render, staticRenderFns } from "./BaseNavigationMenuList.vue?vue&type=template&id=f2f57a32&scoped=true&"
import script from "./BaseNavigationMenuList.vue?vue&type=script&lang=js&"
export * from "./BaseNavigationMenuList.vue?vue&type=script&lang=js&"
import style0 from "./BaseNavigationMenuList.vue?vue&type=style&index=0&id=f2f57a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f57a32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VIcon,VList,VListItem,VListItemAction,VListItemContent,VListItemTitle,VSubheader})
